const ADMIN_URL_BASE = '/admin';
const ADMIN_URL_USER_ACCESS = `${ADMIN_URL_BASE}/userAccess`;
const ADMIN_URL_DATA_MANAGMENT = `${ADMIN_URL_BASE}/dataManagement`;
const ADMIN_URL_TOOLBOX_CONFIG = `${ADMIN_URL_BASE}/toolboxConfig`;
const ADMIN_URL_ENABLEMENT = `${ADMIN_URL_BASE}/enablement`;
// Labs are two pages rather than one: authoring a lab and running an event for it are done by
// different people at different times, and putting them on one tab strip meant a proctor
// mid-event was one click from the step editor.
const ADMIN_URL_LABS_GENERATION = `${ADMIN_URL_BASE}/labGeneration`;
const ADMIN_URL_LABS_EVENTS = `${ADMIN_URL_BASE}/labEvents`;
// SAFE is its own page rather than a tab under Data Management: it is thirteen tables of its own
// and is curated by the `SAFE Admin` role, who need none of the rest of Data Management.
const ADMIN_URL_SAFE = `${ADMIN_URL_BASE}/safe`;
// The assessment builder. Its own page rather than a tab under Data Management, on the same
// reasoning as SAFE: the `Assessment Admin` role holds `page.assessmentAdmin.view` and nothing
// else, so it needs a link it can reach without the rest of Data Management.
const ADMIN_URL_ASSESSMENT = `${ADMIN_URL_BASE}/assessments`;
// The campaign builder/administration. Its own page rather than a tab under Data Management, on the
// same reasoning as SAFE and Assessments: the `Campaign Admin` role holds `page.campaignAdmin.view`
// (and the campaign api grants) and needs a link it can reach without the rest of Data Management.
const ADMIN_URL_CAMPAIGNS = `${ADMIN_URL_BASE}/campaigns`;

export {
  ADMIN_URL_BASE,
  ADMIN_URL_USER_ACCESS,
  ADMIN_URL_DATA_MANAGMENT,
  ADMIN_URL_TOOLBOX_CONFIG,
  ADMIN_URL_ENABLEMENT,
  ADMIN_URL_LABS_GENERATION,
  ADMIN_URL_LABS_EVENTS,
  ADMIN_URL_SAFE,
  ADMIN_URL_ASSESSMENT,
  ADMIN_URL_CAMPAIGNS,
}
